import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import EventDetail from "@/pages/event/page";
import Calendar from "@/pages/calendar/page";
import News from "@/pages/news/page";
import Article from "@/pages/news/article";
import PartnersPage from "@/pages/partners/page";
import CommunityPage from "@/pages/community/page";
import ProsPage from "@/pages/pros/page";
import WatchPage from "@/pages/watch/page";
import DemoAdmin from "@/pages/demo-admin/page";
import HowItWorksPage from "@/pages/how-it-works/page";
import DemoGuidePage from "@/pages/demo/page";
import RevenueDemoPage from "@/pages/demo/revenue/page";
import MultilingualDemoPage from "@/pages/demo/multilingual/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/calendar", element: <Calendar /> },
  { path: "/events/:slug", element: <EventDetail /> },
  { path: "/news", element: <News /> },
  { path: "/news/:slug", element: <Article /> },
  { path: "/partners", element: <PartnersPage /> },
  { path: "/community", element: <CommunityPage /> },
  { path: "/pros", element: <ProsPage /> },
  { path: "/watch", element: <WatchPage /> },
  { path: "/demo-admin", element: <DemoAdmin /> },
  { path: "/how-it-works", element: <HowItWorksPage /> },
  { path: "/demo", element: <DemoGuidePage /> },
  { path: "/demo/revenue", element: <RevenueDemoPage /> },
  { path: "/demo/multilingual", element: <MultilingualDemoPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;